import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import {
  Top10Options,
  TerritoryOptions,
  CurrencyOptions,
} from "../../Constants/retailer";
import loadImage from "blueimp-load-image";

import "./index.css";

const Styles = {
  control: (styles) => ({
    ...styles,
    width: 200,
  }),
};
const earningOptions = Array.from(Array(11).keys())
  .slice(1)
  .map((n) => ({ label: n.toString(), value: n }));

export default function EditEcoEarning(props) {
  const [retailer, setRetailer] = useState(props.retailer);
  const [currentPercent, setCurrentPercent] = useState(0);
  const [content, setContent] = useState(null);
  const [logoImage, setLogoImage] = useState(null);

  const imageButton = useRef();

  useEffect(() => {
    if (props.retailer) {
      setRetailer(props.retailer);
      setCurrentPercent(props.retailer.tokenPercentage);
      setLogoImage(props.retailer.logo);
    }
    setContent(null);
    console.log("props", props);
  }, [props.retailer]);

  const handleSave = () => {
    if (content) {
      props.onSave(currentPercent, content);
    } else {
      props.onSave(currentPercent);
    }
  };

  const selectFile = (e) => {
    if (e.target.files && e.target.files[0]) {
      var content = e.target.files[0];
      const type = content.type;
      loadImage.parseMetaData(content, function (data) {
        var orientation = 0;
        if (data.exif) {
          orientation = data.exif.get("Orientation");
        }
        loadImage(
          content,
          function (canvas) {
            var base64data = canvas.toDataURL(type);
            var img_src = base64data.replace(/^data\:image\/\w+\;base64\,/, "");
            setContent(img_src);
            let img_content = "data:" + type + ";base64," + img_src;
            setLogoImage(img_content);
          },
          {
            canvas: true,
            orientation: orientation,
          }
        );
      });
    }
  };

  return (
    <div
      className="edit-eco-earning modal fade"
      id="edit_eco_earning"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog edit-modal" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <div
              onClick={() => imageButton.current.click()}
              style={{
                backgroundImage: `url(${logoImage})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "contain",
                width: 120,
                height: 130,
                marginLeft: 30,
                cursor: "pointer",
              }}
            ></div>
            <input
              ref={imageButton}
              type="file"
              id="image"
              name="image"
              accept="image/jpeg, image/png"
              className="form-control-file"
              style={{ display: "none" }}
              onChange={selectFile}
            />
            <p className="header-text">{`Update ${
              retailer && retailer.retailerName
            } Earning Values`}</p>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1">
            <Select
              value={earningOptions.find((e) => e.label === currentPercent)}
              onChange={(value) => setCurrentPercent(value.value)}
              options={earningOptions}
              styles={Styles}
            />
            <div className="price-container">
              <div className="input-group">
                <div className="prefix">
                  {CurrencyOptions[retailer ? retailer.territory : "UK"]}
                </div>
                <input
                  type="number"
                  className="form-control form-control-md form-control-alt"
                  value={1}
                  disabled
                />
              </div>
            </div>
            <div className="percent-container">{currentPercent}%</div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-green"
              data-dismiss="modal"
              onClick={() => handleSave()}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/EditEcoEarning/index.js